/** Array of CSS selectors matching all inherently focusable elements */
export const FOCUSABLE_ELEMENTS: string[] = [
  'a[href]',
  'area[href]',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'button:not([disabled])',
  'iframe',
  'object',
  'embed',
  '[contenteditable]',
  '[tabindex]:not([tabindex="-1"])',
];

/** CSS selector string for finding all focusable elements */
export const FOCUSABLE_ELEMENTS_SELECTOR: string = FOCUSABLE_ELEMENTS.join(', ');

/** Returns the first focusable element within the given container, or null if none exists. */
export function getFirstFocusableElement(container: HTMLElement | null | undefined): HTMLElement | null {
  return container?.querySelector<HTMLElement>(FOCUSABLE_ELEMENTS_SELECTOR) ?? null;
}

/** Focuses the first focusable element within the container. Pass `{ fallback: true }` to fall back to focusing the container itself when no focusable child is found. */
export function focusFirstElementIn(container: HTMLElement | null | undefined, options: { fallback?: boolean } = {}): void {
  const { fallback = false } = options;
  (getFirstFocusableElement(container) ?? (fallback ? container : null))?.focus();
}
